<mat-card class="color-card">
  <div mat-card-image class="product-image" [style.background]="'url(' + doc.imageUrl + ')'" alt=""></div>
  <mat-card-footer class="text-left" style="padding: 5px;margin: -15px 0 0 15px;border:1px solid #CCC;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;" ngStyle.xs="padding-left:0px;margin-left:0px;margin:0px;">
    <mat-card-title class="text-left text-overflow-ellipsis colorTitle" >
      {{doc.name}}
    </mat-card-title>
  </mat-card-footer>
</mat-card>
